import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { VscWarning } from "react-icons/vsc";

import ConfirmationModal from "../../../../Dialogs/ConfirmationModal";
import { Color } from "../../../../Form/Button";
import useStyles from "./styles";

type ManageModalFuntion = (allCartons: boolean, cartonSSCC?: string) => void;

export type ConfirmReceiveSSCCHandles = {
  open: ManageModalFuntion;
  close: () => void;
};
type ConfirmReceiveSSCCProps = {
  onConfirmReceive: ManageModalFuntion;
};

const ConfirmReceiveSSCC: ForwardRefRenderFunction<
  ConfirmReceiveSSCCHandles,
  ConfirmReceiveSSCCProps
> = (props, ref) => {
  const { onConfirmReceive } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [modalOpened, setModalOpened] = useState<boolean>(false);
  const [areManyReceive, setAreManyReceive] = useState<boolean>(false);
  const [sscc, setSSCC] = useState<string | undefined>(undefined);

  const onOpenModal = useCallback((allCartons: boolean, cartonSSCC) => {
    setAreManyReceive(allCartons);
    setSSCC(cartonSSCC);
    setModalOpened(true);
  }, []);

  const onCloseModal = useCallback(() => {
    setAreManyReceive(false);
    setSSCC(undefined);
    setModalOpened(false);
  }, []);

  const onSubmit = () => {
    onConfirmReceive(areManyReceive, sscc);
    onCloseModal();
  };

  const titleTranslateKey = areManyReceive ? "receiveAllSSCC" : "receiveSSCC";
  const submitTranslateKey = areManyReceive ? "yesReceiveAll" : "yesReceiveSSCC";

  const messageTranslateKey = areManyReceive
    ? "youAreAboutMarkAllSSCCAsReceived"
    : "areYouSureYouWantToMarkThisSSCCAsReceived";

  const complementMessage = areManyReceive ? "areYouSure" : "";

  const complementTranslateKey = "thisActionCannotbeUndone";

  useImperativeHandle(ref, () => ({
    open: onOpenModal,
    close: onCloseModal,
  }));

  return (
    <ConfirmationModal
      title={translate(titleTranslateKey)}
      open={modalOpened}
      closeModal={() => setModalOpened(false)}
      textSubmit={translate(submitTranslateKey)}
      submit={() => onSubmit()}
      className={classes.confirmModal}
      cancelClassName={classes.cancelButton}
      customColorSave={Color.WARNING}
      type="warning"
      leftIconTitle={<VscWarning color="#F79009" size={20} />}
    >
      <Grid container direction="column">
        <Grid item className={classes.confirmModalText}>
          <span>
            {translate(messageTranslateKey)}?
            <strong>{complementMessage ? ` ${translate(complementMessage)}?` : ""}</strong>
          </span>
        </Grid>
        <Grid item className={classes.confirmModalWarning}>
          <span>{translate(complementTranslateKey)}.</span>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(ConfirmReceiveSSCC);
